import React, { useState } from "react";
import { motion } from "framer-motion";

const Package = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const packages = [
    {
      name: "Advertisement",
      price: "₹5,000",
      duration: "6 months",
      features: [
        "1 Advertisement Slot",
        "Up to 10 Images",
        "Visible on dealer/owner/saler",
      ],
      details:
        "Great for agencies looking to promote their services. Get visible ad placement on homepage for wider reach.",
    },
    {
      name: "Project",
      price: "₹1,80,000",
      duration: "1 year",
      features: [
        "Project Listing on Website",
        "Unlimited Photos & Video",
        "Full Branding & Promotion",
        "Dedicated Support Team",
        "Lead Management Dashboard",
      ],
      details:
        "Designed for full-scale project launches. Get premium visibility, branding, media support, and lead tracking tools.",
    },
    {
      name: "Platinum with multiple projects",
      price: "₹4,50,000",
      duration: "1 year",
      features: [
        "Unlimited Listings",
        "Unlimited Photos & Videos",
        "Dedicated Account Manager",
        "Featured & City-Level Promotion",
        "Google Ads Campaign Included",
        "Legal & Documentation Assistance",
      ],
      details:
        "All-in-one solution for serious sellers and developers. Includes Google Ads, legal help, and full-service listing support.",
    },
  ];

  const addOns = [
    "Professional Property Photoshoot",
    "Drone Footage & Virtual Tours",
    "Legal Document Verification",
    "Social Media Marketing Boost",
    "Google Ads Campaign Setup",
  ];

  const faqs = [
    {
      q: "What happens if my property doesn’t sell in 30 days?",
      a: "You can renew or upgrade your package to get extended visibility and benefits.",
    },
    {
      q: "Can I upgrade my plan anytime?",
      a: "Yes, you can upgrade your plan anytime by contacting our support.",
    },
    {
      q: "Is there a refund policy?",
      a: "Refunds are processed as per the terms and conditions mentioned during purchase.",
    },
    {
      q: "Can I list multiple properties in a single package?",
      a: "Depending on the package, you can list multiple properties. Please check the details above.",
    },
  ];

  const toggleDetails = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <>
      <style>{`
        .hero-banner {
          position: relative;
          height: 411px;
          overflow: hidden;
        }
        .hero-banner video {
          position: absolute;
          top: 0;
          left: 0;
          object-fit: cover;
          width: 100%;
          height: 100%;
          z-index: 0;
        }
        .poster-section {
          background: url('https://via.placeholder.com/1200x200?text=Special+Offer:+Flat+20%25+Off+on+Platinum+Plan') center/cover no-repeat;
          height: 200px;
          margin: 20px 0;
          border-radius: 10px;
        }
        .card:hover {
          transform: translateY(-5px);
          transition: 0.3s ease;
        }
        @media (max-width: 767px) {
          .hero-banner {
            height: 200px;
          }
          .poster-section {
            height: 120px;
          }
        }
      `}</style>

      <div className="container-fluid px-0">
        <motion.div
          className="hero-banner d-flex align-items-center justify-content-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <video autoPlay loop muted playsInline>
            <source src="/assets/Package.mp4" type="video/mp4" />
          </video>
        </motion.div>

        <div className="container my-5">
          <motion.h2
            className="text-center mb-4"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            Choose Your Package
          </motion.h2>
          <div className="row g-4">
            {packages.map((pkg, idx) => (
              <motion.div
                key={idx}
                className="col-lg-4 col-md-6 col-sm-12"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: idx * 0.2 }}
                viewport={{ once: true }}
              >
                <div className="card shadow-sm h-100">
                  <div className="card-header bg-primary text-white text-center">
                    <h4 className="my-2">{pkg.name}</h4>
                  </div>
                  <div className="card-body d-flex flex-column">
                    <h3 className="text-center text-success mb-2">{pkg.price}</h3>
                    <p className="text-center text-muted mb-3">{pkg.duration}</p>
                    <ul className="list-unstyled small mb-3">
                      {pkg.features.map((feature, i) => (
                        <li key={i}>
                          <i className="bi bi-check-circle-fill text-success me-2"></i>
                          {feature}
                        </li>
                      ))}
                    </ul>
                    <button
                      className="btn btn-outline-primary mt-auto w-100"
                      onClick={() => toggleDetails(idx)}
                    >
                      {expandedIndex === idx ? "Hide Details" : "View Details"}
                    </button>
                    {expandedIndex === idx && (
                      <div className="mt-3 border-top pt-2 text-muted small">
                        <strong>Details:</strong>
                        <p className="mb-0">{pkg.details}</p>
                      </div>
                    )}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        <motion.div
          className="container my-5 bg-white p-4 rounded shadow-sm border"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h3 className="text-center mb-4">Bank Payment Details</h3>
          <div className="row">
            <div className="col-md-6">
              <p><strong>Account Holder Name:</strong> kismatkiproperty.com</p>
              <p><strong>Account Number:</strong> 23060200000203</p>
              <p><strong>IFSC Code:</strong> FDRL0002306</p>
              <p><strong>Bank Name:</strong> FEDERAL Bank</p>
              <p><strong>Address:</strong> New Delhi janakpuri, south west delhi-110058</p>
            </div>
            <div className="col-md-6 text-center">
              <p><strong>Scan to Pay:</strong></p>
              <img
                src="/assets/scanner.jpeg"
                alt="Scan QR Code"
                className="img-fluid mt-0"
                style={{ maxWidth: "250px", marginTop: "0px" }}
              />
            </div>
          </div>
        </motion.div>

        <motion.div
          className="container"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <div className="poster-section mb-4"></div>
        </motion.div>

        <div className="container my-5">
          <motion.h3
            className="text-center mb-4"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
          >
            Add-ons & Extra Services
          </motion.h3>
          <motion.ul
            className="list-group list-group-flush w-100 w-md-75 mx-auto"
            initial="hidden"
            whileInView="visible"
            transition={{ staggerChildren: 0.1 }}
            viewport={{ once: true }}
          >
            {addOns.map((item, idx) => (
              <motion.li
                key={idx}
                className="list-group-item"
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.4 }}
              >
                <i className="bi bi-plus-circle-fill text-primary me-2"></i>
                {item}
              </motion.li>
            ))}
          </motion.ul>
        </div>

        <motion.div
          className="container my-5 bg-light p-4 rounded shadow-sm"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <h3 className="text-center mb-4">Why Choose Us?</h3>
          <div className="row text-center">
            {[
              {
                icon: "clock-history",
                title: "20+ Years Trust",
                desc: "Serving India’s real estate sector reliably.",
              },
              {
                icon: "globe",
                title: "Pan-India Reach",
                desc: "Listings visible across all major cities.",
              },
              {
                icon: "shield-check",
                title: "Verified Buyers",
                desc: "Genuine buyers & tenants only.",
              },
              {
                icon: "people",
                title: "Client First",
                desc: "Your satisfaction is our priority.",
              },
            ].map((item, i) => (
              <motion.div
                key={i}
                className="col-12 col-md-6 col-lg-3 mb-3"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.2 }}
                viewport={{ once: true }}
              >
                <i className={`bi bi-${item.icon} fs-1 text-primary mb-2`}></i>
                <h5>{item.title}</h5>
                <p className="text-muted">{item.desc}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <motion.div
          className="container my-5"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <h3 className="text-center mb-4">FAQs</h3>
          <div className="accordion w-100 w-md-75 mx-auto" id="faqAccordion">
            {faqs.map((faq, idx) => (
              <div key={idx} className="accordion-item">
                <h2 className="accordion-header" id={`heading${idx}`}>
                  <button
                    className={`accordion-button ${idx !== 0 ? "collapsed" : ""}`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${idx}`}
                    aria-expanded={idx === 0}
                    aria-controls={`collapse${idx}`}
                  >
                    {faq.q}
                  </button>
                </h2>
                <div
                  id={`collapse${idx}`}
                  className={`accordion-collapse collapse ${idx === 0 ? "show" : ""}`}
                  aria-labelledby={`heading${idx}`}
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body">{faq.a}</div>
                </div>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          className="text-center my-5 px-3"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h4>Still not sure which package suits you?</h4>
          <p>
            Call us at <a href="tel:+919810526380">+91 9810526380</a> or <a href="/contact">Contact Us</a>
          </p>
          <button className="btn btn-primary btn-lg mt-2">Get In Touch</button>
        </motion.div>
      </div>
    </>
  );
};

export default Package;
